/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import Stack from '@mui/material/Stack'
import { Chip } from '@mui/material'


export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(true)

  const getAppTypes = async () => {
    const { response } = await AppService.medialibrary.get({
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }

  const onLoad = () => {
    getAppTypes()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.medialibrary.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])
  const truncateText = (text, wordLimit = 5) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + "..." : text;
  };

  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Priority', accessor: 'priority' },
        { Header: 'Name', accessor: 'name' },
        { Header: 'Description', accessor: 'description' },
        { Header: 'Video Path', accessor: 'video_path' },
        { Header: 'Transcription', accessor: 'transcription' },
        { Header: 'Type', accessor: 'type' },
        { Header: 'App', accessor: 'app' },
        { Header: 'Category', accessor: 'category' },
        { Header: 'Tags', accessor: 'tags' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        priority: data.priority,
        name: data.name ? `${data.name.substring(0,20)}...` : "",
        description: data.description ? `${data.description.replace(/<[^>]+>/g, "").substring(0,40)}...` : "",
        video_path: data.video_path ? `${data.video_path.substring(0,20)}...` : "",
        page_path: truncateText(data.page_path),
        transcription: truncateText(data?.transcription),
        type: data?.type,
        app: data?.app ? "Yes" : "No",
        category: data?.category?.name,
        tags: data.tags?.sort().join(', ') || 'N/A',



        tags: (
          <Stack direction="row" spacing={1}>
            {data.tags.map((tag, index) => (
              <Chip key={index} label={tag} variant="outlined" color="info" size="small" />
            ))}
          </Stack>
        ),
        action: (
          <MDBox>
            <EditModal data={data} handleRefresh={onLoad} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data?._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
